// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1r04idpf{inset:0}._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._kqswh2mm{position:relative}\n._kqswstnw{position:absolute}\n._lcxvglyw{pointer-events:none}\n._tzy47hfw{opacity:var(--_cnddr8)}", ""]);
// Exports
module.exports = exports;
